// components/HamburgerMenu.js
import React from 'react';

const HamburgerMenu = ({ isOpen, onToggle, onItemClick, user, currentSet, showResult, location, handleLogout }) => {
  return (
    <div className={`hamburger-menu ${isOpen ? 'open' : ''}`}>
      <button className="hamburger-button" onClick={onToggle}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      {isOpen && (
        <div className="menu-items">
          <button className="close-menu" onClick={onToggle}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>

          <button onClick={() => {
            onItemClick();
            onToggle();
          }}>
            Select Set
          </button>

          <button onClick={() => {
            onItemClick('library');
            onToggle();
          }}>
            Library
          </button>

          {currentSet && currentSet.length > 0 && !showResult && location.pathname === '/' && (
            <button onClick={() => {
              onItemClick('order');
              onToggle();
            }}>
              Change Order
            </button>
          )}

          <button onClick={() => {
            onItemClick('profile');
            onToggle();
          }}>
            User Profile
          </button>

          <button
            className="logout-item"
            onClick={() => {
              handleLogout();
              onToggle();
            }}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default HamburgerMenu;
